import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=e5f3a122"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=e5f3a122&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5f3a122')) {
      api.createRecord('e5f3a122', component.options)
    } else {
      api.reload('e5f3a122', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=e5f3a122", function () {
      api.rerender('e5f3a122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/preLoadTruckPickup/detail.vue"
export default component.exports